// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--ZYlLY","content":"content--eGnkP","blueAction":"blueAction--VKqq0"};